<template>
  <div>
    <el-dialog     :append-to-body="true"
                   :draggable="true"
        v-model="clickDateDialog"
        title="选择日期"
        width="500">
        <el-date-picker
            v-model="monthDate"
            type="month"
            format="YYYY/MM"
            value-format="YYYY-MM"
            placeholder="请选择"
            @click.stop
            @calendar-change.stop/>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="clickDateDialog = false">取 消</el-button>
          <el-button type="primary" @click="toMethod">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {pushApportion, pushOrder, pushCourse, pushAdvance, pushEquip, pushZhaoShangCRMOrder,
  sendKeXiao,sendYeJi,pushTraineeRatio,pushEfficiencyRatio,pushOrderDivert,pushWeekAttRatio,contractRate,pushReturnVisitRate} from "@/api/tools";
import {ElNotification} from "element-plus";

export default {
  name: "Tools",
  data() {
    return {
      methodName:"",
      monthDate:null,
      clickDateDialog:false
    }
  },
  methods: {
    message(title, info, type) {
      ElNotification({
        title: title,
        message: info,
        type: type,
      })
    },
    toMethod(){
      this[this.methodName]();
    },
    pushApportion() {
      this.$message.success('系统正在处理中。。。')
      pushApportion().then(val => {
        if (val.code == 200) {
          this.message("已发送", "系统推送完成！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },
    pushOrder() {
      this.$message.success('系统正在处理中。。。')
      pushOrder().then(val => {
        if (val.code == 200) {
          this.message("已发送", "系统推送完成！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },

    sendYeJi() {
      if (this.clickDateDialog ===  false){
        this.methodName = "sendYeJi";
        this.clickDateDialog = true;return
      }
      this.$message.success('系统正在处理中。。。')
      let year = null;
      let month = null;
      if (this.monthDate){
        const date = this.monthDate.split('-');
        year = date[0]; month = date[1];
      }
      let form = new FormData();
      form.append("year",year);
      form.append("month",month);
      sendYeJi(form).then(val => {
        if (val.code == 200) {
          this.message("已发送", "系统推送完成！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },
    sendReturnVisitRate() {
      if (this.clickDateDialog ===  false){
        this.methodName = "sendReturnVisitRate";
        this.clickDateDialog = true;return
      }
      this.$message.success('系统正在处理中。。。')
      let year = null;
      let month = null;
      if (this.monthDate){
        const date = this.monthDate.split('-');
        year = date[0]; month = date[1];
      }
      let form = new FormData();
      form.append("year",year);
      form.append("month",month);
      pushReturnVisitRate(form).then(val => {
        if (val.code == 200) {
          this.message("已发送", "系统推送完成！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },
    sendContractRate() {
      if (this.clickDateDialog ===  false){
        this.methodName = "sendContractRate";
        this.clickDateDialog = true;return
      }
      this.$message.success('系统正在处理中。。。')
      let year = null;
      let month = null;
      if (this.monthDate){
        const date = this.monthDate.split('-');
        year = date[0]; month = date[1];
      }
      let form = new FormData();
      form.append("year",year);
      form.append("month",month);
      contractRate(form).then(val => {
        if (val.code == 200) {
          this.message("已发送", "系统推送完成！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },
    sendKeXiao() {
      if (this.clickDateDialog ===  false){
        this.methodName = "sendKeXiao";
        this.clickDateDialog = true;return
      }
      this.$message.success('系统正在处理中。。。')
      let year = null;
      let month = null;
      if (this.monthDate){
        const date = this.monthDate.split('-');
        year = date[0]; month = date[1];
      }
      let form = new FormData();
      form.append("year",year);
      form.append("month",month);
      sendKeXiao(form).then(val => {
        if (val.code == 200) {
          this.message("已发送", "系统推送完成！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },


    pushCourse() {
      this.$message.success('系统正在处理中。。。')
      pushCourse().then(val => {
        if (val.code == 200) {
          this.message("已发送", "系统推送完成！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },
    pushAdvance() {
      this.$message.success('系统正在处理中。。。')
      pushAdvance().then(val => {
        if (val.code == 200) {
          this.message("已发送", "系统推送完成！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },

    pushEquip() {
      this.$message.success('系统正在处理中。。。')
      pushEquip().then(val => {
        if (val.code == 200) {
          this.message("已发送", "系统推送完成！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },

    pushZhaoShangCRMOrder() {
      this.$message.success('系统正在处理中。。。')
      pushZhaoShangCRMOrder().then(val => {
        if (val.code == 200) {
          this.message("已发送", "系统推送完成！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },

    sendEfficiencyRatio(){
      if (this.clickDateDialog ===  false){
        this.methodName = "sendEfficiencyRatio";
        this.clickDateDialog = true;return
      }
      let year = null;
      let month = null;
      if (this.monthDate){
        const date = this.monthDate.split('-');
        year = date[0]; month = date[1];
      }
      let form = new FormData();
      form.append("year",year);
      form.append("month",month);
      this.$message.success('系统正在处理中。。。')
      pushEfficiencyRatio(form).then(val => {
        if (val.code == 200) {
          this.message("已发送", "推送效比！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },
    sendTraineeRatio(){
      if (this.clickDateDialog ===  false){
        this.methodName = "sendTraineeRatio";
        this.clickDateDialog = true;return
      }
      let year = null;
      let month = null;
      if (this.monthDate){
        const date = this.monthDate.split('-');
        year = date[0]; month = date[1];
      }
      let form = new FormData();
      form.append("year",year);
      form.append("month",month);
      this.$message.success('系统正在处理中。。。')
      pushTraineeRatio(form).then(val => {
        if (val.code == 200) {
          this.message("已发送", "推送试课转化！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },
    pushOrderDivert(){
      this.$message.success('系统正在处理中。。。')
      pushOrderDivert().then(val => {
        if (val.code == 200) {
          this.message("已发送", "推送引流转化！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    },
    pushWeekAttRatio(){
      if (this.clickDateDialog ===  false){
        this.methodName = "pushWeekAttRatio";
        this.clickDateDialog = true;return
      }
      let year = null;
      let month = null;
      if (this.monthDate){
        const date = this.monthDate.split('-');
        year = date[0]; month = date[1];
      }
      let form = new FormData();
      form.append("year",year);
      form.append("month",month);
      this.$message.success('系统正在处理中。。。')
      pushWeekAttRatio(form).then(val => {
        if (val.code == 200) {
          this.message("已发送", "推送成功！", "success")
        } else {
          this.message("推送失败", val.message, "error")
        }
      });
    }
  }
}
</script>

<style scoped>

</style>